module.exports = __webpack_public_path__ + "static/media/madeinindia.d3c1ba46.png";